<template>
  <v-container pa-0>
    <date-field
      v-model="question.value"
      :label="label"
      :disabled="disabled"
      :hint="question.instructionText"
      :rules="[required ? rules.required : true]"
      narrow
    >
    </date-field>
  </v-container>
</template>

<script>
import QuestionMixin from "./QuestionMixin";
import DateField from "@/components/DateField";

export default {
  name: "DateQuestion",
  mixins: [QuestionMixin],
  data() {
    return {
      rules: {
        required: val => !!val || "Required"
      }
    };
  },
  components: {
    DateField
  }
};
</script>
